import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69138e068dff8b0014f98ce8/s_installer_au_maroc/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69138e068dff8b0014f98ce8/s_installer_au_maroc/src/app/about/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69138e068dff8b0014f98ce8/s_installer_au_maroc/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69138e068dff8b0014f98ce8/s_installer_au_maroc/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69138e068dff8b0014f98ce8/s_installer_au_maroc/src/components/ui/AppImage.tsx");
